import { render, staticRenderFns } from "./TipoPedidoModal.vue?vue&type=template&id=e96f6af2&scoped=true"
import script from "./TipoPedidoModal.vue?vue&type=script&lang=js"
export * from "./TipoPedidoModal.vue?vue&type=script&lang=js"
import style0 from "./TipoPedidoModal.vue?vue&type=style&index=0&id=e96f6af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96f6af2",
  null
  
)

export default component.exports